import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const ClaimData = () => {
    
    const sections = [
        { label: "Category", value: "Category", items: [] },
        { label: "Status", value: "Status", items: [] },
        { label: "Raised Type", value: "RaisedType", items: [] },
        { label: "Amount Type", value: "AmountType", items: [] },
    ];

    return (
        <MasterData pageTitle="Claim" sections={sections} />
    );
};

export default ClaimData;